import { Observable, of, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { catchError, map } from 'rxjs/operators';
import { APICONSTANTS } from '../../constants/api-constants';
import { HostnameService } from '../basic/hostname.service';
import { ProjetAgenceDTO, ProjetAgenceModel } from '../../models/simple-types/projet-models.model';
import { GenericCrudService } from '../basic/generic.crud.service';
import { Injectable } from '@angular/core';

@Injectable()

export class ProjetAgenceService extends GenericCrudService<ProjetAgenceModel> {
  constructor(http: HttpClient, protected toastrService: ToastrService,
    protected hostnameService: HostnameService) {
    super(http, toastrService, APICONSTANTS.ROUTEPROJETAGENCE, hostnameService);
  }

  createOrSave(projetAgence: ProjetAgenceModel, modifs: string) {
    if (!projetAgence.id) {
      return this.saveModifs(projetAgence, modifs);
    } else {
      return this.updateModifs(projetAgence.id, projetAgence, modifs);
    }
  }

  getFromAgence(id: number): Observable<ProjetAgenceModel[]> {
    return this.http.get<ProjetAgenceModel[]>(APICONSTANTS.URLAPI.value + this.route + 'getFromAgence/' + id).pipe(catchError( err => this.requestCatchError(err, 'getFromAgence')));
  }

  saveModifs(projetAgenceModel: ProjetAgenceModel, modifs: string): Observable<ProjetAgenceModel> {
    let projAgenceDTO = new ProjetAgenceDTO();
        projAgenceDTO.projetAgence = projetAgenceModel;
        projAgenceDTO.modifs = modifs;
    return this.http.post<ProjetAgenceModel>(APICONSTANTS.URLAPI.value + this.route + 'postModifs/', projAgenceDTO).pipe(catchError( err => this.requestCatchError(err, 'L\'enregistrement')));
  }

  updateModifs(id: number, projetAgenceModel: ProjetAgenceModel, modifs: string): Observable<ProjetAgenceModel> {
    let projAgenceDTO = new ProjetAgenceDTO();
        projAgenceDTO.projetAgence = projetAgenceModel;
        projAgenceDTO.modifs = modifs;
    return this.http.put<ProjetAgenceModel>(APICONSTANTS.URLAPI.value + this.route + 'updateModifs/' + id, projAgenceDTO).pipe(catchError( err => this.requestCatchError(err, 'Update')));
  }

  requestCatchError(error, origineError): Observable<any> {
    let errorMessage = '';
    if (error.status === 400) {
      this.toastrService.error(error.error, 'Erreur client');
      errorMessage = `Error: ${error.error.message}`;
      return throwError(errorMessage);
    }
    if (error.error instanceof ErrorEvent) {
        // client-side error
        this.toastrService.error(origineError + '  a échoué.', 'Erreur client');
        errorMessage = `Error: ${error.error.message}`;
    } else {
        // server-side error
        this.toastrService.error(origineError + '  a échoué.', 'Erreur serveur');
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}